/* eslint-disable react/no-danger */
import { Link } from "gatsby";
import React from "react";
import ratioLogoSvg from "../images/ratio-wordmark-v02a.svg";
import MenuModal from "./MenuModal";
import MenuButton from "./MenuButton";
import { closeMenu } from "../utils/menuHelpers";

export default function HeaderDefault() {
  return (
    <div id="global-header" className="header px-medium pt-medium pt-ml-small">
      <div id="global-nav">
        <ul className="grid-fixed-2 grid-align-center">
          <li>
            <Link to="/" onClick={closeMenu}>
              <div className="ratio-logo">
                {/* <img src={ratioLogoSvg} alt="Ratio Lighting Australia" /> */}
                <div
                  className="svgContainer"
                  dangerouslySetInnerHTML={{
                    __html:
                      '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 663.68 212.24"><defs></defs><path class="cls-1" d="M865.23,551.5h30.63c6.38,0,9.43-4.79,9.43-8.27,0-9.15-2.61-24.68-34.69-24.68-12.05,0-20.62,2.32-25.7,6.82s-7.84,10-8,16.41c0,1-.44,1.45-1.45,1.45H806.58c-1,0-1.46-.44-1.46-1.45,0-35,30.93-52.41,65.48-52.41,20.61,0,36.87,4.5,48.77,13.65s17.86,23.08,17.86,41.66v61c0,5.67,3.92,9.88,10.31,9.88h6.53c1,0,1.45.43,1.45,1.45v24.39c0,1-.43,1.45-1.45,1.45h-11.9c-16.7,0-25.12-4.79-30.34-13.94-.73-1.16-1.6-1.31-2.62-.29-3.77,3.92-9.87,7.84-18.29,11.47s-19,5.66-31.65,5.66c-20,0-34.84-4.5-44.56-13.35S800,612,800,598.25C800,572.12,821.67,551.5,865.23,551.5Zm-6,65.48c33.39,0,46-19.31,46-36v-2c0-1-.43-1.45-1.45-1.6H866.1c-29.33,0-34.12,11.76-34.12,20.91C832,606.52,838.37,617,859.27,617Z" transform="translate(-629.26 -433.48)"/><path class="cls-1" d="M961.51,493.87c0-1,.43-1.45,1.45-1.45h25.26c1,0,1.45-.58,1.45-1.6V450.76c0-1,.44-1.46,1.45-1.46h29.18c1,0,1.46.44,1.46,1.46v40.06c0,1,.58,1.45,1.59,1.6h31.21c1,0,1.46.43,1.46,1.45v23.81c0,1-.44,1.45-1.46,1.45h-31.21c-1,0-1.45.44-1.59,1.45v81.15c0,7.55,4.21,12.2,13.5,12.2h19.3c1,0,1.46.58,1.46,1.6v25.84c0,1-.44,1.45-1.46,1.45h-23.22c-15.1,0-25.84-3.34-32.09-9.87s-9.58-17.13-9.58-32.09V520.58c0-1-.43-1.45-1.45-1.45H963c-1,0-1.45-.43-1.45-1.45Z" transform="translate(-629.26 -433.48)"/><path class="cls-1" d="M1083.31,440c0-1,.44-1.45,1.45-1.45h32.81c1,0,1.45.44,1.45,1.45V473.4c0,1-.43,1.45-1.45,1.45h-32.81c-1,0-1.45-.43-1.45-1.45Zm1.45,53.86c0-1,.59-1.45,1.6-1.45h28.74c1,0,1.46.43,1.46,1.45v147.5c0,1-.44,1.45-1.46,1.45h-28.74c-1,0-1.45-.44-1.6-1.45Z" transform="translate(-629.26 -433.48)"/><path class="cls-1" d="M1218.91,489.37c46.45,0,74,31.94,74,78.25s-27.58,78.1-74,78.1c-46.6,0-73.6-31.65-73.6-78.1C1145.31,520.73,1172.45,489.37,1218.91,489.37Zm-30.63,114.11c7.11,9,17.42,13.5,30.63,13.5,13.64,0,24.1-4.5,31.21-13.5s10.74-20.91,10.74-35.86-3.48-26.86-10.6-35.71-17.56-13.36-31.35-13.36c-13.21,0-23.52,4.5-30.63,13.36s-10.89,20.76-10.89,35.71S1181,594.48,1188.28,603.48Z" transform="translate(-629.26 -433.48)"/><path class="cls-1" d="M629.26,434.93c0-1,.58-1.45,1.6-1.45h86.81c32.81,0,61.84,28.45,61.84,64.31,0,30.05-20.61,49.21-34,56.47a1.19,1.19,0,0,0-.29,1.74L783,641.08c0,.43.29.43.29.87s-.58.87-1.74.87H752.08a2.76,2.76,0,0,1-2-1.16q-17.62-39.2-35.13-79.12c-.58-1-1.16-1.45-1.74-1.45H662.65c-1,0-1.45.43-1.6,1.45v78.83c0,1-.43,1.45-1.45,1.45H630.86c-1,0-1.45-.44-1.6-1.45Zm31.79,95.81c0,1,.58,1.46,1.6,1.46h52.84c16.84,0,32.09-15.68,32.09-34.41,0-19.16-16-35.13-33.25-35.13H662.65c-1,0-1.45.43-1.6,1.16Z" transform="translate(-629.26 -433.48)"/></svg>',
                  }}
                />
              </div>
            </Link>
          </li>
          <li className="nav">
            <ul className="nav-list-horizontal nav-list-right fs-small fs-ml-large">
              <li data-nosnippet>
                <MenuButton />
              </li>
              <li data-nosnippet>
                <Link
                  to="/filter/"
                  className="nav-list-item"
                  data-nosnippet
                  onClick={closeMenu}
                >
                  Filter
                </Link>
              </li>
              {/* <li data-nosnippet>
              <Link to="/approach/" className="nav-list-item" data-nosnippet>
                Approach
              </Link>
            </li> */}
              <li data-nosnippet>
                <Link to="/projects/" className="nav-list-item" data-nosnippet>
                  Projects
                </Link>
              </li>
              <li data-nosnippet>
                <Link
                  to="/info/"
                  className="nav-list-item"
                  data-nosnippet
                  onClick={closeMenu}
                >
                  Info
                </Link>
              </li>
            </ul>
          </li>
        </ul>
        <hr className="mt-small mt-ms-medium mt-ml-small" />
      </div>
      <MenuModal />
    </div>
  );
}
